import { styled } from '../styled';

import { Button } from './button';

export const StyledButton = styled(Button)`
  align-self: center;
`;
